import { useTranslation } from "react-i18next";
import logo from "../../common/images/logo.svg";
import { links } from "../../common/data/Links/Navbar.links";
import MobileMenu from "./Mobile.menu";

const Header = () => {
  const { t } = useTranslation(["common"]);

  return (
    <header className="bg-yellow-500 bg-opacity-30 backdrop-blur-lg fixed top-0 left-0 right-0  flex items-center justify-between z-20">
      <figure className="rounded-r-full">
        <img src={logo} alt="logo" className="w-40" />
      </figure>

      <nav className="pl-4 pr-8 gap-1 text-slate-800 text-sm hidden xl:flex">
        {links.map((link, key) => (
          <a
            key={key}
            href={link.to}
            className="flex items-center hover:bg-yellow-500 hover:text-yellow-800 rounded-2xl px-4 py-2"
          >
            {t(link.name)}
          </a>
        ))}
      </nav>
      <MobileMenu />
    </header>
  );
};

export default Header;
